module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.b06871f281fee6b241d60582ae9369b9.ttf?";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 1354
// module chunks = 0